export const thousandSeparator = (value: string | number) => {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    useGrouping: true,
  })
  return formatter.format(Number(value))
}

export function unThousandSeparator(value: string | number) {
  const split = value.toString().split('.')
  return split.join('')
}
